module.exports = __webpack_public_path__ + "1c32b88fe87a37406226467c8a97f00c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/quizzes-gray.png
// module id = 1731
// module chunks = 0